import * as I18n from 'i18n-js';
import * as React from 'react';
import { Link } from 'react-router';

const ACTIVE_CLASS = 'feed-container__tab--active';

export class FeedTabs extends React.Component<{}, null> {
  render() {
    return (
      <nav className="feed-container__tabs">
        <ul>
          <li className="feed-container__tab">
            <Link to="/my/feed" activeClassName={ACTIVE_CLASS}>
              {I18n.t('discovery.feed.tabs.feed')}
            </Link>
          </li>
          <li className="feed-container__tab">
            <Link to="/my/feed/customize" activeClassName={ACTIVE_CLASS}>
              {I18n.t('discovery.feed.tabs.customize')}
            </Link>
          </li>
          <li className="feed-container__tab">
            <Link to="/watched_products" activeClassName={ACTIVE_CLASS}>
              {I18n.t('discovery.feed.tabs.watchList')}
            </Link>
          </li>
          <li className="feed-container__tab">
            <Link to="/browsing_history" activeClassName={ACTIVE_CLASS}>
              {I18n.t('discovery.feed.tabs.recentlyViewed')}
            </Link>
          </li>
        </ul>
      </nav>
    );
  }
}

export default FeedTabs;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/feed/tabs.tsx